module.exports = __webpack_public_path__ + "img/pattern1 copy 11.73f526bb.svg";